// How a rating reads (TX-US-0040). Pure: the picker, the form and the list are beside it.

// Mirrors MIN_STARS, MAX_STARS and MAX_COMMENT_LENGTH in trex/counterparties/ratings/models.py.
export const STARS = [1, 2, 3, 4, 5];
export const MAX_COMMENT_LENGTH = 4000;

// "★★★★☆" for four stars.
export const starsText = (stars) => '★'.repeat(stars) + '☆'.repeat(STARS.length - stars);

// What the register and the profile show: "★ 3.8 (5)", or "Not rated".
export function averageText({ rating_average: average, rating_count: count }) {
  if (!count || average == null) return 'Not rated';
  return `★ ${average} (${count})`;
}

// A sentence for a screen reader, where "★ 3.8 (5)" says nothing.
export function averageLabel({ rating_average: average, rating_count: count }) {
  if (!count || average == null) return 'Not rated';
  return `${average} out of 5 stars from ${count} rating${count === 1 ? '' : 's'}`;
}

// The register's rating filter. Mirrors RatingFilter in trex/counterparties/register.py.
export const RATING_FILTERS = [
  { code: '4', label: '★ 4 and up' },
  { code: '3', label: '★ 3 and up' },
  { code: '2', label: '★ 2 and up' },
  { code: 'unrated', label: 'Not rated' },
];

export const ROLE_LABELS = { COMMERCIAL: 'BD', OPERATIONS: 'Operations' };
export const raterRoles = (rating) => rating.author_roles
  .map((role) => ROLE_LABELS[role] ?? role).join(', ');
